import { ServiceFetch } from '../service-fetch'

export default class FactCreditNoteSupplierModel extends ServiceFetch {
    getFactCreditNoteSupplierBy = (data) => this.authFetch({
        url: 'fact-credit-note-supplier/getFactCreditNoteSupplierBy',
        method: 'POST',
        body: JSON.stringify(data),
    })
}